import { Injectable } from "@angular/core";
import { DateRangeParam, UserPreference } from "../../models";
import { appSettings, errorMessages } from "../../settings";
import { AnalyticsService } from "../analytics.service";
import { CommonService } from "../common.service";
import { WidgethelperService } from "../widgethelper.service";
import { BaseService } from "./base.service";
import { WidgetParam } from "../../models/DataModels";

@Injectable()
export class MheMonitoringSummaryService extends BaseService{

  constructor(
    private _commonService: CommonService,
    private _widgetHelper: WidgethelperService,
    private _analyticsService: AnalyticsService) {
    super();
  }

  init(widget: any) {
    widget.dataLoaded = false;

    let param = new WidgetParam();
    let dateParam: DateRangeParam = new DateRangeParam();
    let setting = widget.widgetsettings;
    if(setting.PickType == 'PostShip' || setting.PickType == null || setting.PickType == '') {
      setting.PickType = appSettings.Last2Weeks;
    }
    
    dateParam.RangeValue = this._widgetHelper.GetSummaryType(setting.PickType);
    dateParam.RangeNumber = this._widgetHelper.GetSummaryTypeNo(setting.PickType);

    this._analyticsService.getDates(dateParam).subscribe(data => {
      if (
        data.Start_Date.toString() != "0001-01-01T00:00:00" &&
        data.End_Date.toString() != "0001-01-01T23:59:59.999"
      ) {
        param.StartDate = new Date(data.Start_Date);
        param.EndDate = new Date(data.End_Date);
        let userPref: UserPreference = this._commonService.getUserPreference();
        param.CustomerId = userPref.CustomerId;
        param.FacilityId = userPref.FacilityId;
        
        this.GetMHEMonitoringSummary(widget, param);
      }
    });
  }

  GetMHEMonitoringSummary(widget, param: WidgetParam) {
    let userPref: UserPreference = this._commonService.getUserPreference();
    param.CustomerId = userPref.CustomerId;
    param.FacilityId = userPref.FacilityId;

    this._analyticsService.GetMHEMonitoringSummary(param).subscribe(
      result => {
        widget.errorMessage = null;
        if (result && result.length > 0) {
          let xAxisData = [];
          let MIN_1_2 = [];
          let MIN_2_3 = [];
          let MIN_3_4 = [];
          let MIN_4_5 = [];
          let MIN_GT_5 = [];
         
          result.forEach(row => {            
            if (row.QUEUE_HOUR && xAxisData.indexOf(row.QUEUE_HOUR) == -1) {
              MIN_1_2.push(row.MIN_1_2); 
              MIN_2_3.push(row.MIN_2_3); 
              MIN_3_4.push(row.MIN_3_4); 
              MIN_4_5.push(row.MIN_4_5); 
              MIN_GT_5.push(row.MIN_GT_5); 
              xAxisData.push(row.QUEUE_HOUR);
            }
          });

          widget.chartOptions = this.chartOptions();
          this.addDataSeries(widget.chartOptions, MIN_1_2, "1-2 Min", "line");
          this.addDataSeries(widget.chartOptions, MIN_2_3, "2-3 Min", "line");
          this.addDataSeries(widget.chartOptions, MIN_3_4, "3-4 Min", "line");
          this.addDataSeries(widget.chartOptions, MIN_4_5, "4-5 Min", "line");
          this.addDataSeries(widget.chartOptions, MIN_GT_5, ">5 Min", "line");
          this.addZoomBar(widget.chartOptions);
          widget.chartOptions.xAxis.data = xAxisData;
          widget.chartOptions.xAxis.axisLabel.rotate = 45;
          widget.chartOptions.color = ['#3398DB', '#148F77','#F0FF33','#80FF33','#DC7633'];
        } 
        else {
          widget.errorMessage = errorMessages.noWidgetData;
        }
        widget.dataLoaded = true;
      },
      err => {
        console.log("GetMHEMonitoringSummary", err);
        widget.errorMessage = errorMessages.apiError;
        widget.dataLoaded = true;
      }
    );
  }

  reload(widget: any) {}

  remove(widget: any) {}
}



// WEBPACK FOOTER //
// ./src/app/services/widgets/mhe-monitoring-summary.service.ts